import classes from "./aboutUs.module.scss";
import banner from "../../assets/imgs/about-bg.jpg";
import OptimizedImage from "../../components/OptimizedImage";

const AboutUs = () => {
  return (
    <main className={classes.container}>
      <section className={classes.banner}>
        <div className={classes.banner__overlay}>
          <div className={classes.banner__pattern} aria-hidden="true" />
          <div className={classes.banner__body}>
            <h2 className={classes.banner__body__title}>
              Have A Dream provides a <span>Unique</span> travel experience
            </h2>
            <p className={classes.banner__body__text}>
              Through volunteering, culture exchange, adventure, and road trips.
            </p>
          </div>
        </div>
      </section>

      <section className={`${classes.split}`}>
        <figure className={`${classes.media}`}>
          <OptimizedImage
            alt="Students walking along a scenic overlook"
            className={`${classes.mediaImg}`}
            sources={[
              {
                type: "image/jpeg",
                srcSet: banner,
              },
            ]}
            fallback={{
              src: "../../assets/imgs/notFound/fallback-image.png",
            }}
          />
        </figure>
        <div className={`${classes.copy}`}>
          <h2 className={`${classes.h2}`}>About Us</h2>
          <p className={`${classes.lead}`}>
            In 2013, when the term 'youth exchange' was unfamiliar to many in
            Egypt, a man with dreams traveled to China to experience
            intercultural exchange and spread awareness of such opportunities.
            Mahmoud Abdelmageed, inspired by his work with UNESCO, returned home
            determined to open new doors for Egyptian youth. In 2014, Have A
            Dream was born, with the mission to provide life-changing
            opportunities for young Egyptians to explore different cultures,
            exchange ideas, and make a global impact through volunteering.
          </p>
          <p className={`${classes.lead}`}>
            Since then, we have developed projects with the goal of enriching
            youth experiences. We’ve expanded into diverse fields such as
            teaching, farming, community service, and construction. In response
            to the Beirut explosion, we provided crucial support, demonstrating
            our commitment to helping communities in need.
          </p>
          <p className={`${classes.lead}`}>
            Our journey has taken us across Europe, Asia, and Africa, and we are
            proud to be accredited by Erasmus+ and the European Solidarity
            Corps. Through these programs, we’ve launched projects that tackle
            youth development, entrepreneurship, the arts, environmental issues,
            and cultural heritage.
          </p>
          <p className={`${classes.lead}`}>
            With a community of more than 1300 adventurers who have traveled to
            50 countries across 3 continents, we remain committed to empowering
            youth through volunteering and intercultural exchange.
          </p>
          <p className={`${classes.lead}`}>
            Join us in creating a more connected, compassionate world and making
            a lasting difference through youth empowerment and intercultural
            exchange
          </p>
        </div>
      </section>
      <div className={classes.body}></div>
    </main>
  );
};

export default AboutUs;
